// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/rubik-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/rubik-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/rubik-medium-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/rubik-medium-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/rubik-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/rubik-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/background.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/images/phone_background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: bold;
  font-style: normal;
}

* {
  box-sizing: border-box;
}

input,
button {
  font-family: inherit;
}

body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: center;
  background-size: cover;
}

.glass {
  backdrop-filter: blur(16px) saturate(180%);
  background-color: rgba(17, 25, 40, 0.75);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.125);

  padding: 1rem;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid hsla(0, 0%, 100%, .1);
  margin: 1rem;
}

body {
  min-height: 100vh;
  margin: 0;
  font-family: "Rubik";
  color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
}

main {
  width: max(60%, 1000px);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;

  input,
  button {
    font-family: inherit;
  }

  input {
    background-color: #1f2a37;
    color: white;
    border: 1px solid #4b5663;
    border-radius: 4px;
    box-shadow: none;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    padding: .5rem 1rem;
  }

  input:focus {
    border-color: palevioletred;
    box-shadow: 0 0 0, inset 0 0 2px hsla(0, 0%, 100%, .95);
    outline: transparent;
  }

  button {
    background-color: palevioletred;
    background-image: linear-gradient(180deg, hsla(0, 0%, 100%, .15), hsla(0, 0%, 100%, 0));
    border: 1px solid palevioletred;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    padding: .5rem 1rem;
    box-shadow: 0 1px 1px rgba(18, 21, 26, .075);
    color: white;
    cursor: pointer;
  }

  button:hover {
    background-image: none;
  }
}


.main-container {
  padding: 1.5rem;
  padding-right: 2.5rem;

  .today-highlight {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-between;
    flex-wrap: wrap;

    div:has(>img) {
      display: flex;
    }

    img {
      align-self: flex-start;
      height: 4rem;
    }

    div:has(>.temp, >.feels-like) {
      display: flex;
    }

    .temp {
      font-weight: 500;
      font-size: 4rem;
      margin: 0;
    }

    .feels-like {
      align-self: flex-end;
      padding-left: 10px;
      color: #9ca3af;
    }

    .brief {
      color: #9ca3af;
      margin-top: 0;
    }

    div:has(>.min, >.max) {
      display: flex;
      align-items: center;
      gap: 1.5rem;


      svg {
        width: 2rem;
        height: 2rem;
      }

      >div {
        display: flex;
        align-items: center;
        gap: .5rem;

        p:first-child {
          margin: 0;
          color: #9ca3af;
        }

        p:last-child {
          margin: 0;
          font-size: 1.4rem;
          font-weight: 500;
        }
      }
    }
  }

  .today-details {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;

    >div {
      display: flex;
      gap: .5rem;

      svg {
        width: 1.5rem;
        fill: white;
      }

      p {
        margin: 5px;
      }

      p:first-child {
        color: #9ca3af;
      }

      p:last-child {
        font-size: 1.1rem;
      }
    }
  }
}

.hourly {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  text-align: center;

  .hour {
    border-left: 1px solid hsla(0, 0%, 100%, .1);

    &:first-child {
      border-left: none;
    }

    img {
      height: 48px;
    }

    p {
      margin: 0;
    }

    p:first-child {
      font-weight: 500;
    }

    p:last-child {
      color: #9ca3af;
      font-size: .95rem;
    }
  }
}

.week {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  >div {
    flex: 1;
  }

  .day {

    >div:first-child {
      display: flex;
      gap: .3rem;

      img {
        height: 50px;
      }

      .temp {
        font-weight: 500;
        font-size: 2rem;
        margin: 0;
      }

      .brief {
        color: #9ca3af;
        font-size: .95rem;
        margin: 0;
      }
    }

    .date {
      padding-left: 1rem;
    }
  }

  .extra-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    padding-left: .5rem;
    justify-content: space-between;

    >div:nth-child(-n + 2) {
      border-bottom: 1px solid hsla(0, 0%, 100%, .1);
      padding-bottom: .5rem;
    }

    >div:nth-child(n + 3) {
      padding-top: .5rem;
    }

    svg {
      fill: white;
      width: 1.5rem;
    }

    >div {
      display: flex;
      gap: .3rem;

      p:first-child {
        color: #9ca3af;
        font-size: .95rem;
      }

      p {
        margin: 5px;
      }
    }

  }
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}




@media only screen and (max-width: 1000px) {
  main {
    width: 90%;
  }
}


@media only screen and (max-width: 768px) {
  body {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
  }

  main {
    width: 100%;
    padding: .5rem;
  }

  .location {
    display: flex;
    gap: .3rem;
    width: 100%;

    input {
      width: 100%;
    }
  }

  .hourly {
    grid-template-columns: repeat(3, 1fr);

    .hour:nth-child(4) {
      border-left: none;
    }

    .hour {
      padding-left: .5rem;
      padding-right: .5rem;
    }

    .hour:first-child,
    .hour:nth-child(4) {
      padding-left: 0;
    }

    .hour:last-child,
    .hour:nth-child(3) {
      padding-right: 0;
    }

    .hour:nth-child(n - 4) {
      padding-bottom: 1rem;
    }

    .hour:nth-child(n + 4) {
      border-top: 1px solid hsla(0, 0%, 100%, .1);
      padding-top: 1rem;
    }
  }


  .main-container {
    .today-details {
      grid-template-columns: repeat(2, 1fr);
      justify-items: start;
    }
  }
}


.main-container {
  z-index: -1;
}

.location {
  display: flex;
  gap: .3rem;

  .input-holder {
    flex: 1;
    position: relative;

    .auto-complete {
      position: absolute;
      width: 100%;
      background: #1f2a37;
      border-radius: 3px;
      overflow: hidden;
      cursor: pointer;

      >div {
        border-bottom: 1px solid hsla(0, 0%, 100%, .1);
        padding: .8rem 1rem;
      }

      >div:last-child {
        border-bottom: none;
      }

      >div:hover {
        background: #9ca3af;
      }

      p:first-child {
        font-weight: 500;
        margin: 0;
      }

      p:last-child {
        font-size: .9rem;
        margin: 0;
        margin-top: 5px;
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;0DACiE;EACjE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DACgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DAC8D;EAC9D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,yDAAwD;EACxD,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;;EAE5C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;;EAET;;IAEE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,uDAAuD;IACvD,oBAAoB;EACtB;;EAEA;IACE,+BAA+B;IAC/B,uFAAuF;IACvF,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,4CAA4C;IAC5C,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE,eAAe;EACf,qBAAqB;;EAErB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,eAAe;;IAEf;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,eAAe;MACf,SAAS;IACX;;IAEA;MACE,oBAAoB;MACpB,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,cAAc;MACd,aAAa;IACf;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,WAAW;;;MAGX;QACE,WAAW;QACX,YAAY;MACd;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,UAAU;;QAEV;UACE,SAAS;UACT,cAAc;QAChB;;QAEA;UACE,SAAS;UACT,iBAAiB;UACjB,gBAAgB;QAClB;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,qBAAqB;;IAErB;MACE,aAAa;MACb,UAAU;;MAEV;QACE,aAAa;QACb,WAAW;MACb;;MAEA;QACE,WAAW;MACb;;MAEA;QACE,cAAc;MAChB;;MAEA;QACE,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;;EAElB;IACE,4CAA4C;;IAE5C;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;;EAET;IACE,OAAO;EACT;;EAEA;;IAEE;MACE,aAAa;MACb,UAAU;;MAEV;QACE,YAAY;MACd;;MAEA;QACE,gBAAgB;QAChB,eAAe;QACf,SAAS;MACX;;MAEA;QACE,cAAc;QACd,iBAAiB;QACjB,SAAS;MACX;IACF;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;;IAE9B;MACE,8CAA8C;MAC9C,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,aAAa;IACf;;IAEA;MACE,aAAa;MACb,UAAU;;MAEV;QACE,cAAc;QACd,iBAAiB;MACnB;;MAEA;QACE,WAAW;MACb;IACF;;EAEF;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;;AAKA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE;EACF;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,WAAW;;IAEX;MACE,WAAW;IACb;EACF;;EAEA;IACE,qCAAqC;;IAErC;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;MACnB,oBAAoB;IACtB;;IAEA;;MAEE,eAAe;IACjB;;IAEA;;MAEE,gBAAgB;IAClB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,2CAA2C;MAC3C,iBAAiB;IACnB;EACF;;;EAGA;IACE;MACE,qCAAqC;MACrC,oBAAoB;IACtB;EACF;AACF;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;;EAEV;IACE,OAAO;IACP,kBAAkB;;IAElB;MACE,kBAAkB;MAClB,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;;MAEf;QACE,8CAA8C;QAC9C,mBAAmB;MACrB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,gBAAgB;QAChB,SAAS;MACX;;MAEA;QACE,gBAAgB;QAChB,SAAS;QACT,eAAe;MACjB;IACF;EACF;AACF","sourcesContent":["@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-regular-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-regular-webfont.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-medium-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-medium-webfont.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-bold-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-bold-webfont.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n}\n\n* {\n  box-sizing: border-box;\n}\n\ninput,\nbutton {\n  font-family: inherit;\n}\n\nbody {\n  background-image: url('./assets/images/background.webp');\n  background-position: center;\n  background-size: cover;\n}\n\n.glass {\n  backdrop-filter: blur(16px) saturate(180%);\n  background-color: rgba(17, 25, 40, 0.75);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.125);\n\n  padding: 1rem;\n}\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid hsla(0, 0%, 100%, .1);\n  margin: 1rem;\n}\n\nbody {\n  min-height: 100vh;\n  margin: 0;\n  font-family: \"Rubik\";\n  color: white;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nmain {\n  width: max(60%, 1000px);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.top-bar {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n\n  input,\n  button {\n    font-family: inherit;\n  }\n\n  input {\n    background-color: #1f2a37;\n    color: white;\n    border: 1px solid #4b5663;\n    border-radius: 4px;\n    box-shadow: none;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    padding: .5rem 1rem;\n  }\n\n  input:focus {\n    border-color: palevioletred;\n    box-shadow: 0 0 0, inset 0 0 2px hsla(0, 0%, 100%, .95);\n    outline: transparent;\n  }\n\n  button {\n    background-color: palevioletred;\n    background-image: linear-gradient(180deg, hsla(0, 0%, 100%, .15), hsla(0, 0%, 100%, 0));\n    border: 1px solid palevioletred;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.5rem;\n    padding: .5rem 1rem;\n    box-shadow: 0 1px 1px rgba(18, 21, 26, .075);\n    color: white;\n    cursor: pointer;\n  }\n\n  button:hover {\n    background-image: none;\n  }\n}\n\n\n.main-container {\n  padding: 1.5rem;\n  padding-right: 2.5rem;\n\n  .today-highlight {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    div:has(>img) {\n      display: flex;\n    }\n\n    img {\n      align-self: flex-start;\n      height: 4rem;\n    }\n\n    div:has(>.temp, >.feels-like) {\n      display: flex;\n    }\n\n    .temp {\n      font-weight: 500;\n      font-size: 4rem;\n      margin: 0;\n    }\n\n    .feels-like {\n      align-self: flex-end;\n      padding-left: 10px;\n      color: #9ca3af;\n    }\n\n    .brief {\n      color: #9ca3af;\n      margin-top: 0;\n    }\n\n    div:has(>.min, >.max) {\n      display: flex;\n      align-items: center;\n      gap: 1.5rem;\n\n\n      svg {\n        width: 2rem;\n        height: 2rem;\n      }\n\n      >div {\n        display: flex;\n        align-items: center;\n        gap: .5rem;\n\n        p:first-child {\n          margin: 0;\n          color: #9ca3af;\n        }\n\n        p:last-child {\n          margin: 0;\n          font-size: 1.4rem;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .today-details {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    justify-items: center;\n\n    >div {\n      display: flex;\n      gap: .5rem;\n\n      svg {\n        width: 1.5rem;\n        fill: white;\n      }\n\n      p {\n        margin: 5px;\n      }\n\n      p:first-child {\n        color: #9ca3af;\n      }\n\n      p:last-child {\n        font-size: 1.1rem;\n      }\n    }\n  }\n}\n\n.hourly {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  text-align: center;\n\n  .hour {\n    border-left: 1px solid hsla(0, 0%, 100%, .1);\n\n    &:first-child {\n      border-left: none;\n    }\n\n    img {\n      height: 48px;\n    }\n\n    p {\n      margin: 0;\n    }\n\n    p:first-child {\n      font-weight: 500;\n    }\n\n    p:last-child {\n      color: #9ca3af;\n      font-size: .95rem;\n    }\n  }\n}\n\n.week {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n\n  >div {\n    flex: 1;\n  }\n\n  .day {\n\n    >div:first-child {\n      display: flex;\n      gap: .3rem;\n\n      img {\n        height: 50px;\n      }\n\n      .temp {\n        font-weight: 500;\n        font-size: 2rem;\n        margin: 0;\n      }\n\n      .brief {\n        color: #9ca3af;\n        font-size: .95rem;\n        margin: 0;\n      }\n    }\n\n    .date {\n      padding-left: 1rem;\n    }\n  }\n\n  .extra-info {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    padding-left: .5rem;\n    justify-content: space-between;\n\n    >div:nth-child(-n + 2) {\n      border-bottom: 1px solid hsla(0, 0%, 100%, .1);\n      padding-bottom: .5rem;\n    }\n\n    >div:nth-child(n + 3) {\n      padding-top: .5rem;\n    }\n\n    svg {\n      fill: white;\n      width: 1.5rem;\n    }\n\n    >div {\n      display: flex;\n      gap: .3rem;\n\n      p:first-child {\n        color: #9ca3af;\n        font-size: .95rem;\n      }\n\n      p {\n        margin: 5px;\n      }\n    }\n\n  }\n}\n\n.loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border-left-color: #09f;\n  animation: spin 1s ease infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n\n@media only screen and (max-width: 1000px) {\n  main {\n    width: 90%;\n  }\n}\n\n\n@media only screen and (max-width: 768px) {\n  body {\n    background: url('./assets/images/phone_background.webp')\n  }\n\n  main {\n    width: 100%;\n    padding: .5rem;\n  }\n\n  .location {\n    display: flex;\n    gap: .3rem;\n    width: 100%;\n\n    input {\n      width: 100%;\n    }\n  }\n\n  .hourly {\n    grid-template-columns: repeat(3, 1fr);\n\n    .hour:nth-child(4) {\n      border-left: none;\n    }\n\n    .hour {\n      padding-left: .5rem;\n      padding-right: .5rem;\n    }\n\n    .hour:first-child,\n    .hour:nth-child(4) {\n      padding-left: 0;\n    }\n\n    .hour:last-child,\n    .hour:nth-child(3) {\n      padding-right: 0;\n    }\n\n    .hour:nth-child(n - 4) {\n      padding-bottom: 1rem;\n    }\n\n    .hour:nth-child(n + 4) {\n      border-top: 1px solid hsla(0, 0%, 100%, .1);\n      padding-top: 1rem;\n    }\n  }\n\n\n  .main-container {\n    .today-details {\n      grid-template-columns: repeat(2, 1fr);\n      justify-items: start;\n    }\n  }\n}\n\n\n.main-container {\n  z-index: -1;\n}\n\n.location {\n  display: flex;\n  gap: .3rem;\n\n  .input-holder {\n    flex: 1;\n    position: relative;\n\n    .auto-complete {\n      position: absolute;\n      width: 100%;\n      background: #1f2a37;\n      border-radius: 3px;\n      overflow: hidden;\n      cursor: pointer;\n\n      >div {\n        border-bottom: 1px solid hsla(0, 0%, 100%, .1);\n        padding: .8rem 1rem;\n      }\n\n      >div:last-child {\n        border-bottom: none;\n      }\n\n      >div:hover {\n        background: #9ca3af;\n      }\n\n      p:first-child {\n        font-weight: 500;\n        margin: 0;\n      }\n\n      p:last-child {\n        font-size: .9rem;\n        margin: 0;\n        margin-top: 5px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
